import React from 'react'
import { Button, Collapse } from '@material-ui/core'
import { useStyles } from './Styles'
import { FormattedMessage } from 'react-intl'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'

const PermissionsList = ({ permissions }) => {
  let classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)
  return (
    !!permissions && !!permissions.length &&
    (permissions.length > 2 ?
      <>
        <ul className={classes.PermissionList}>
          {permissions.slice(0, 2).map((permission) => (
            <li key={permission.id}>{permission.name}</li>
          ))}
        </ul>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <ul className={classes.PermissionList}>
            {permissions.slice(2, permissions.length).map((permission) => (
              <li key={permission.id}>{permission.name}</li>
            ))}
          </ul>
        </Collapse>
        <Button className={classes.PermissionBtn} color="primary" onClick={() => setExpanded(!expanded)}>
          <FormattedMessage
            id={!!expanded ? 'Roles.List.Table.Permissions.Less' : 'Roles.List.Table.Permissions.More'}/>
          {!!!!expanded ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
        </Button>
      </>
      :
      <ul className={classes.PermissionList}>
        {permissions.map((permission) => (
          <li key={permission.id}>{permission.name}</li>
        ))}
      </ul>)
  )
}
export default PermissionsList